import { useQuery } from '@tanstack/react-query'

import {
  extractTokenFromClientSession,
  SessionAuthenticated,
  SessionUnauthenticated
} from 'modules/customer'
import { ListingCategoryType } from 'modules/products'
import { getQueryClient, QueryKey } from 'shared/api'

import { fetchCategoriesQuery } from '../api'

export const useQueryCategories = (
  session: SessionAuthenticated | SessionUnauthenticated
) => {
  const token = extractTokenFromClientSession(session)

  return useQuery({
    queryKey: [QueryKey.categories, token],
    queryFn: () => fetchCategoriesQuery(token),
    initialData: getQueryClient().getQueryData<ListingCategoryType[]>([
      QueryKey.categories,
      token
    ]),
    enabled: session.status !== 'loading',
    staleTime: 60000
  })
}

export const queryFetchCategories = async (token: string) => {
  return await getQueryClient().fetchQuery<ListingCategoryType[]>({
    queryKey: [QueryKey.categories, token],
    queryFn: () => fetchCategoriesQuery(token)
  })
}

export const queryPrefetchCategories = async (token: string) => {
  return getQueryClient().prefetchQuery({
    queryKey: [QueryKey.categories, token],
    queryFn: () => fetchCategoriesQuery(token)
  })
}
